export default "{\n    \"label\": \"Técnico\"\n}\n"